import React, { useEffect, useState, useMemo, useCallback } from "react";
import TableBackground from "../../components/TableBackground";
import { debounce } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import PaginationComponent from "../../components/Pagination/Pagination";
import SearchComponent from "../../components/Search";
import { getPendingAgents } from "../../redux/Agents/agentsAction";
import EmptyState from "../../components/EmptyState";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const PendingAgentsTable = () => {
  const [searchValue, setSearchValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { pendingAgentsData, pendingAgentsTotal, pendingAgentsLoading } =
    useSelector((state) => state.agents);

  // COMPLAINTS PAGE CHANGE
  const onPageChange = (val) => {
    const { page } = val;
    setCurrentPage(page);
    dispatch(
      getPendingAgents({ page: page, value: "all", search: searchValue })
    );
  };

  const handleSearch = useMemo(
    () =>
      debounce((val) => {
        //  api to dispatch and make the actions for search
        dispatch(getPendingAgents({ page: 1, value: "all", search: val }));
      }, 750),
    [dispatch]
  );

  const handleChange = useCallback(
    (e) => {
      let val = e.target.value;
      setSearchValue(val);
      handleSearch(val);
    },
    [handleSearch]
  );

  useEffect(() => {
    dispatch(getPendingAgents({ page: 1, value: "all", search: searchValue }));
  }, [dispatch, searchValue]);

  return (
    <div>
      <TableBackground>
        {/* SEARCH AND FILTER SECTION */}
        <section className="flex gap-4  pt-4">
          <div className="w-full relative px-4">
            <SearchComponent
              placeholder="Search..."
              searchValue={searchValue}
              handleChange={handleChange}
            />
          </div>
        </section>

        <section className="mt-[30px] mb-[24px]">
          {pendingAgentsLoading ? (
            <div className="animate-pulse w-full mt-4 px-4 pb-4 mb-4">
              <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg  w-full"></div>
            </div>
          ) : (
            <>
              {pendingAgentsData?.length === 0 ? (
                <EmptyState text="There's no data for this filter yet" />
              ) : (
                <table>
                  <thead>
                    <tr>
                      <th scope="col" className="px-4 pb-2">
                        First Name
                      </th>
                      <th scope="col" className="px-4 pb-2">
                        Last Name
                      </th>
                      <th scope="col" className="px-4 pb-2">
                        Phone Number
                      </th>
                      <th scope="col" className="px-4 pb-2">
                        Date Registered
                      </th>

                      <th scope="col" className="px-4 pb-2">
                        {" "}
                        State
                      </th>
                      <th scope="col" className="px-4 pb-2">
                        LGA
                      </th>

                      <th scope="col" className="px-4 pb-2">
                        Status
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {pendingAgentsData?.map((data, index) => {
                      return (
                        <tr
                          key={index}
                          className="relative cursor-pointer hover:bg-[#edf7ee]"
                          onClick={() =>
                            navigate(`/agent-approval-info/${data?.id}`)
                          }
                        >
                          <td className="px-4 capitalize">
                            {data?.first_name || "N/A"}
                          </td>
                          <td className="px-4 capitalize">
                            {data?.last_name || "N/A"}
                          </td>
                          <td className="px-4">
                            {data?.phone_number || "N/A"}
                          </td>
                          <td className="px-4">
                            {moment(data?.created).format("lll")}
                          </td>
                          <td className="px-4">{data?.state || "N/A"}</td>

                          <td className="px-4">{data?.lga || "N/A"}</td>

                          {/* APPROVAL STATUS */}
                          <td className="">
                            <div
                              className={
                                data.status === "active"
                                  ? "px-4 success-badge"
                                  : data.status === "suspended"
                                  ? "ml-4 px-4 error-badge"
                                  : "ml-4 px-4 na-badge"
                              }
                            >
                              <p className="capitalize">
                                {data.status === "active"
                                  ? data?.status
                                  : data.status === "suspended"
                                  ? data?.status
                                  : "N/A"}
                              </p>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </>
          )}

          {!pendingAgentsLoading && pendingAgentsData?.length > 0 ? (
            <div className="mt-1">
              <PaginationComponent
                page={currentPage}
                onPageChange={(page) => onPageChange({ page })}
                pageSize={10}
                totalItems={pendingAgentsTotal}
              />
            </div>
          ) : (
            ""
          )}
        </section>
      </TableBackground>
    </div>
  );
};

export default PendingAgentsTable;
